var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 790"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 19",
    opacity: 0.3,
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#3ACF9A"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 18",
    cx: 17,
    cy: 17,
    r: 13,
    fill: "#3ACF9A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13 17L16 20L21 14",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailCheck);
export default __webpack_public_path__ + "static/media/emailCheck.7bbcbf55059e0658bf9aa4510ca82da2.svg";
export { ForwardRef as ReactComponent };